import { ProMappedHeaders } from "./pro-mapped-headers";

export class ProLabelMappingProfile {
    id: number = 0;
    proType: string = '';
    createdById: number = 0;
    updatedById: number = 0;
    createdAt: Date = new Date();
    updatedAt: Date = new Date();
    mappedHeaders: ProMappedHeaders[] = [];
    
    static mapProperties(item: any): ProLabelMappingProfile {
        return {
            id: item.id,
            proType: item.pro_type,
            createdById: item.created_by,
            updatedById: item.updated_by,
            createdAt: item.created_at,
            updatedAt: item.updated_at,
            mappedHeaders: item.mapped_headers.map(header => ProMappedHeaders.mapProperties(header))
        };
    }
}
